import { BEYOND_WORDS_PROJECT_ID } from "@helper/getEnvVariables";
interface WindowData {
  title?: string;
  articleid?: string;
}
export const scrollFlags = {
  isProgrammatic: false,
};

export const registerPlayerEvents = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  player: any,
  useAudioAnalytics: ReturnType<
    (typeof import("@hooks/useAnalyticsCall/useAudioAnalytics"))["useAudioAnalytics"]
  >,
) => {
  let isFirstTime = true;

  const data = (window as { _data?: WindowData })._data;
  const articleTitle: string =
    typeof data?.title === "string" ? data.title : "";
  const articleId: string = data?.articleid || "0";
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  const audioId: string = `${BEYOND_WORDS_PROJECT_ID}::${articleId}`;
  let audioListenedTime = 0;
  let audioDuration = 0;
  let audioListenedpercentage = 0;
  let audioSpeed = 1;
  const calculateAudioPercentage = (
    listenedTime: number,
    duration: number,
  ): number => {
    return duration === 0 ? 0 : Math.floor((listenedTime / duration) * 100);
  };

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("VisibilityChanged", () => {
    if (player.widgetStyle === "closed-by-user") {
      audioListenedTime = Number(player.currentTime) || 0;
      /* eslint-enable @typescript-eslint/no-unsafe-member-access */
      audioListenedpercentage = calculateAudioPercentage(
        audioListenedTime,
        audioDuration,
      );
      useAudioAnalytics(
        "audio_close",
        articleTitle,
        audioId,
        audioListenedTime,
        audioDuration,
        audioListenedpercentage,
        audioSpeed,
      );
      return;
    }
    if (isFirstTime) {
      isFirstTime = false;
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (player?.userInterface?.isVisible !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      player.widgetStyle = player.userInterface.isVisible ? "none" : "standard";
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("PlaybackEnded", () => {
    scrollFlags.isProgrammatic = true;
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  });

  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("PressedChangeRate", () => {
    audioListenedTime = Number(player.currentTime) || 0;
    audioSpeed = Number(player.playbackRate) || 1;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    audioListenedpercentage = calculateAudioPercentage(
      audioListenedTime,
      audioDuration,
    );
    useAudioAnalytics(
      "audio_click_speed",
      articleTitle,
      audioId,
      audioListenedTime,
      audioDuration,
      audioListenedpercentage,
      audioSpeed,
    );
  });

  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("PressedPrevSegment", () => {
    audioListenedTime = Number(player.currentTime) || 0;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    audioListenedpercentage = calculateAudioPercentage(
      audioListenedTime,
      audioDuration,
    );
    useAudioAnalytics(
      "audio_rewind",
      articleTitle,
      audioId,
      audioListenedTime,
      audioDuration,
      audioListenedpercentage,
      audioSpeed,
    );
  });

  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("PressedNextSegment", () => {
    audioListenedTime = Number(player.currentTime) || 0;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    audioListenedpercentage = calculateAudioPercentage(
      audioListenedTime,
      audioDuration,
    );
    useAudioAnalytics(
      "audio_forward",
      articleTitle,
      audioId,
      audioListenedTime,
      audioDuration,
      audioListenedpercentage,
      audioSpeed,
    );
  });

  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("PressedPause", () => {
    audioListenedTime = Number(player.currentTime) || 0;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    audioListenedpercentage = calculateAudioPercentage(
      audioListenedTime,
      audioDuration,
    );
    useAudioAnalytics(
      "audio_pause",
      articleTitle,
      audioId,
      audioListenedTime,
      audioDuration,
      audioListenedpercentage,
      audioSpeed,
    );
  });
  let audioEvent: string = "audio_start";
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  player.addEventListener("PressedPlay", () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    audioDuration = Number(player.duration) || 0;
    audioListenedTime = Number(player.currentTime) || 0;
    audioSpeed = Number(player.playbackRate) || 1;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    audioListenedpercentage = calculateAudioPercentage(
      audioListenedTime,
      audioDuration,
    );
    useAudioAnalytics(
      audioEvent,
      articleTitle,
      audioId,
      audioListenedTime,
      audioDuration,
      audioListenedpercentage,
      audioSpeed,
    );
    audioEvent = audioEvent === "audio_start" ? "audio_resume" : audioEvent;
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  player.addEventListener("<any>", () => {
    document
      .querySelectorAll<HTMLElement>(".bwp .player-title")
      .forEach((el) => {
        el.style.setProperty("font-size", "14px", "important");
        el.style.setProperty("color", "#212529", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .duration-in-mins")
      .forEach((el) => {
        el.style.setProperty("font-size", "12px", "important");
        el.style.setProperty("color", "#212529", "important");
      });
    document
      .querySelectorAll<HTMLElement>(".bwp .playback-time")
      .forEach((el) => {
        el.style.setProperty("font-size", "16px", "important");
      });
  });

  const element = document.querySelector('[data-testid="article-body"]');
  const styleMap = {
    PlaybackEnded: {
      userSelect: "auto",
      backgroundColor: "#F7F3F4",
      textColor: "#212529",
      iconColor: "#B10442",
    },
    PlaybackPaused: {
      userSelect: "auto",
      backgroundColor: "#F7F3F4",
      textColor: "#212529",
      iconColor: "#B10442",
    },
    PlaybackPlaying: {
      userSelect: "none",
      backgroundColor: "#B10442",
      textColor: "#FAFAFA",
      iconColor: "#FAFAFA",
    },
  } as const;

  (Object.keys(styleMap) as Array<keyof typeof styleMap>).forEach((event) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    player.addEventListener(event, () => {
      /* eslint-disable @typescript-eslint/no-unsafe-member-access */
      player.backgroundColor = styleMap[event].backgroundColor;
      player.textColor = styleMap[event].textColor;
      player.iconColor = styleMap[event].iconColor;
      /* eslint-enable @typescript-eslint/no-unsafe-member-access */
      if (element) {
        (element as HTMLElement).style.userSelect = styleMap[event].userSelect;
      }
    });
  });
};
